<template>
  <form role="search" action="." @submit.prevent="submit">
    <InputText
      btn="go"
      aria-label="Search Terms"
      autocomplete="off"
      type="search"
      placeholder="Enter text or page..."
      ref="input"
      v-model.trim="formData.terms"
      @reset="reset"
    />
  </form>
</template>

<script>
import InputText from './InputText.vue'

export default {
  name: 'SearchForm',

  data() {
    return {
      formData: {
        terms: '',
      },
    }
  },

  inject: ['isMobile'],

  methods: {
    submit() {
      this.$emit('submit', this.formData)
      if (this.isMobile) {
        // Hide the virtual keyboard after submit.
        this.$refs.input.blur()
      } else {
        // Move the focus from the submit button back to the input.
        this.$refs.input.focus()
      }
    },

    reset() {
      // SearchResults only show if terms is non-blank, so emitting
      // submit with blank terms will clear the results area.
      this.$set(this.formData, 'terms', '')
      this.$emit('submit', this.formData)
    },
  },

  components: {
    InputText,
  },
}
</script>
